import { Route } from '@angular/router';
import { authenticatedGuard, canManageUsersGuard, unauthenticatedGuard } from '@insolution/auth-data-access';
import { currentTenantGuard } from '@insolution/tenant-data-access';
import { canCurateHelpGuard, canManageAnnouncementsGuard, canManageTenantsGuard } from '@insolution/auth-data-access';
import { announcementRoutes } from '@insolution/announcement-feature';
import { helpCurationRoutes } from '@insolution/help-feature';
import { DashboardPage } from '@insolution/insolution-manager-feature-dashboard';
import { availabilityGuard } from '@insolution/availability-data-access';

export const appRoutes: Route[] = [
  {
    path: 'select-tenant',
    loadComponent: () =>
      import('@insolution/insolution-manager-feature-layouts').then((m) => m.InsolutionManagerFeatureEntryLayout),
    children: [
      {
        path: '',
        loadComponent: () => import('@insolution/insolution-manager-feature-tenants').then((m) => m.SelectTenantPage),
        data: {
          title: 'common.select-tenant',
          breadcrumb: 'common.select-tenant',
        },
      },
    ],
    data: { appType: 'Manager' },
    runGuardsAndResolvers: 'always',
    canActivate: [authenticatedGuard, availabilityGuard],
  },
  {
    path: 'availability',
    loadComponent: () =>
      import('@insolution/insolution-manager-feature-layouts').then((m) => m.InsolutionManagerFeatureEntryLayout),
    loadChildren: () => import('@insolution/insolution-manager-feature-availability').then((m) => m.availabilityRoutes),
    data: { title: 'navigation.availability', breadcrumb: 'navigation.availability', appType: 'Manager' },
    runGuardsAndResolvers: 'always',
    canActivate: [availabilityGuard],
  },
  {
    path: 'auth',
    loadComponent: () =>
      import('@insolution/insolution-manager-feature-layouts').then((m) => m.InsolutionManagerFeatureEntryLayout),
    loadChildren: () => import('@insolution/insolution-manager-feature-auth').then((m) => m.authRoutes),
    data: { title: 'navigation.auth', breadcrumb: 'navigation.auth', appType: 'Manager' },
    canActivate: [unauthenticatedGuard],
  },
  {
    path: 'patients/:patientId/consults/:consultId',
    loadChildren: () => import('@insolution/insolution-manager-feature-consults').then((m) => m.consultRoutes),
    runGuardsAndResolvers: 'always',
    canActivate: [currentTenantGuard, authenticatedGuard, availabilityGuard],
    outlet: 'popup',
    data: { appType: 'Manager' },
  },
  {
    path: 'patients/:patientId/consults/:consultId/order-summary',
    loadComponent: () =>
      import('@insolution/insolution-manager-feature-layouts').then(
        (m) => m.InsolutionManagerFeatureConsultOrderLayout
      ),
    loadChildren: () => import('@insolution/insolution-manager-feature-orders').then((m) => m.orderSummaryRoutes),
    runGuardsAndResolvers: 'always',
    canActivate: [currentTenantGuard, authenticatedGuard, availabilityGuard],
    outlet: 'popup',
    data: { appType: 'Manager' },
  },
  {
    path: '',
    loadComponent: () =>
      import('@insolution/insolution-manager-feature-layouts').then((m) => m.InsolutionManagerFeatureDefaultLayout),
    children: [
      {
        path: 'patients',
        loadChildren: () => import('@insolution/insolution-manager-feature-patients').then((m) => m.patientRoutes),
      },
      {
        path: 'users',
        loadChildren: () => import('@insolution/insolution-manager-feature-users').then((m) => m.userRoutes),
        canActivate: [canManageUsersGuard],
      },
      {
        path: 'tenants',
        loadChildren: () => import('@insolution/insolution-manager-feature-tenants').then((m) => m.tenantRoutes),
        canActivate: [canManageTenantsGuard],
      },
      {
        path: 'announcements',
        children: announcementRoutes,
        canActivate: [canManageAnnouncementsGuard],
      },
      {
        path: 'help-curation',
        children: helpCurationRoutes,
        canActivate: [canCurateHelpGuard],
        data: {
          title: 'navigation.help-curation',
          breadcrumb: 'navigation.help-curation',
        },
      },
      {
        path: 'dashboard',
        component: DashboardPage,
        data: {
          title: 'navigation.dashboard',
          breadcrumb: 'navigation.dashboard',
        },
      },
      {
        path: 'open-consults',
        loadChildren: () => import('@insolution/insolution-manager-feature-consults').then((m) => m.openConsultsRoutes),
        data: {
          title: 'navigation.open-consults',
          breadcrumb: 'navigation.open-consults',
        },
      },
      {
        path: 'orders',
        loadChildren: () => import('@insolution/insolution-manager-feature-orders').then((m) => m.orderRoutes),
      },
      { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
    ],
    data: { appType: 'Manager' },
    runGuardsAndResolvers: 'always',
    canActivate: [authenticatedGuard, currentTenantGuard, availabilityGuard],
  },
  { path: '**', redirectTo: '/' },
];
